import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
} from "@/components/ui/sidebar"

import {
  ASSESSOR_VIEW_TOGGLE,
  DEBUG_EVENTS_TOGGLE,
  DevToggle,
} from "./dev-toggle"

/**
 * Replay-only dev tools for the sidebar, scoped to /admin/replay.
 *
 * - "Assessor View" reveals the hidden adversarial grading (AssessorView panel).
 * - "Debug Events" reveals the raw event dump in the embedded SimulationSurface.
 *
 * Both are OFF by default and behave identically to the chat Debug Events
 * toggle, so the demo driver flips them on/off live without surprises.
 */
export function ReplayDevTools() {
  return (
    <SidebarGroup className="px-2 pb-1">
      <SidebarGroupLabel>Replay Dev Tools</SidebarGroupLabel>
      <SidebarMenu>
        <DevToggle spec={ASSESSOR_VIEW_TOGGLE} />
        <DevToggle spec={DEBUG_EVENTS_TOGGLE} />
      </SidebarMenu>
    </SidebarGroup>
  )
}
